module.exports = __webpack_public_path__ + "images/zoom_landing_laptop.png";


//////////////////
// WEBPACK FOOTER
// ./vively/images/zoom_landing_laptop.png
// module id = 862
// module chunks = 3